import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Skeleton, Tooltip, Typography } from "@mui/material";
import React from "react";
import useFetchData from "../../hooks/useFetchData";
import { useParams } from "react-router-dom";
import Avatar from "../avatar/Avatar";

const ChildCard = () => {
  const { isLoading, data: user } = useFetchData("auth/profile");
  const { studentId } = useParams();

  const child = user?.children?.find((child) => child._id === studentId);

  if (child) {
    return (
      <Card className='flex items-center min-w-180px'>
        <Avatar 
          size="small"
          alt={child.code}
          src={`photos/${child.photo}`} 
          variant="square" 
        />
        <div className='px-4 py-1'>
          <Tooltip title={`${child.fullName}`}>
            <Typography variant='inherit' color='primary' className='text-xl font-bold'>{isLoading ? <Skeleton /> : child.code}</Typography>
          </Tooltip>
          <p className='text-muted-foreground opacity-50 text-xs uppercase'>Child</p>
        </div>
      </Card>
    );
  }

  return <></>;
};

export default ChildCard;
